/* tslint:disable */
/* eslint-disable */
/**
 * 3DSurvey API
 * Frontend API for 3d Survey
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteProjectInput
 */
export interface DeleteProjectInput {
    /**
     * 
     * @type {string}
     * @memberof DeleteProjectInput
     */
    projectUUID: string;
}

/**
 * Check if a given object implements the DeleteProjectInput interface.
 */
export function instanceOfDeleteProjectInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "projectUUID" in value;

    return isInstance;
}

export function DeleteProjectInputFromJSON(json: any): DeleteProjectInput {
    return DeleteProjectInputFromJSONTyped(json, false);
}

export function DeleteProjectInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteProjectInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'projectUUID': json['projectUUID'],
    };
}

export function DeleteProjectInputToJSON(value?: DeleteProjectInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'projectUUID': value.projectUUID,
    };
}

